module.exports = __webpack_public_path__ + "static/media/bunq.585602e6.png";